(function ($, window) {
    "use strict";
    DSV.ui.responsiveTables = {
        DOM: {
            table: DSV.DOM.responsiveTables,
        },
        constants: {
            deviceHasTouch: $(document.body).parent().hasClass('touchevents')
        },
        init: function () {
            this.wrapTables();
            this.addSwipeIcon();
        },
        /**
         * Creates the wrapper for the table
         */
        wrapTables: function() {
            var tables = this.DOM.table;

            tables.each(function(index, table) {
                // Create the wrapper container
                var wrapper = document.createElement('div');
                $(wrapper).addClass('responsive-table__wrapper');
                // Insert wrapper before el in the DOM tree
                table.parentNode.insertBefore(wrapper, table);
                // Move el into wrapper
                wrapper.appendChild(table);
            });
        },
        /**
         * Adds the swipe icon to each table if on mobile and there's scroll width
         */
        addSwipeIcon: function() {
            var tables = this.DOM.table;
            var that = this;
            tables.each(function(index, table) {
                // Add a collection of DOM elements needing an eventlistener
                var eventHolders = $(icon).add(table).add(table.parentNode);
                // Check if there's any scroll width
                var hasScrollBar = $(table).width() > $(table).parent().width();
                if (hasScrollBar && that.constants.deviceHasTouch) {
                    // Create icon
                    var icon = document.createElement('img');
                    $(icon).attr("src", "https://dsv-media-premium.azureedge.net/frontend/base/static-new/dist/svg/swipefilled.svg");
                    $(icon).addClass('responsive-table__icon');

                    /**
                     * Removes the event handlers
                     * @param {object} scope 
                     */
                    var removeEventHandlers = function() {
                        // Remove event handlers
                        $(eventHolders).off('click.responsiveTable scroll.responsiveTable');
                        // Remove event handler for specific table
                        DSV.DOM.window.off("scroll.responsive-table" + index);
                    }

                    // Add eventhandlers with namespace
                    eventHolders.on('click.responsiveTable scroll.responsiveTable', function() {
                        $(icon).addClass('responsive-table__icon--inactive');
                        removeEventHandlers();
                    });

                    // Add eventhandler with namespace for specific table
                    DSV.DOM.window.on("scroll.responsive-table" + index, DSV.tools.throttle(function() {
                        // Check if element is in viewport and has not already been detected
                        if (!$(table).hasClass('table--inView') && that.isElementInViewport(table)) {
                            $(table).addClass('table--inView')
                            setTimeout(function() {
                                // Hide icon
                                $(icon).addClass('responsive-table__icon--inactive');
                                removeEventHandlers();
                            }, 4000)
                        };
                    }, 250));
                    // Insert to DOM
                    $(icon).insertAfter(table);
                }
            });
        },
        /**
         * Returns false if not in viewport, returns true if any of its four corners are visible.
         * Note: If element has rounded corners this will not work as expected since it's detected with elementFromPoint
         * @param {Element} el 
         */
        isElementInViewport: function(el) { // https://stackoverflow.com/a/15203639
            var rect    = el.getBoundingClientRect(),
            vWidth      = window.innerWidth || doc.documentElement.clientWidth,
            vHeight     = window.innerHeight || doc.documentElement.clientHeight,
            efp         = function (x, y) { return document.elementFromPoint(x, y) };

            if (rect.right < 0 
                || rect.bottom < 0 
                || rect.left > vWidth 
                || rect.top > vHeight) {
                    return false;
                }

            return (
                el.contains(efp(rect.left,  rect.top))
            ||  el.contains(efp(rect.right, rect.top))
            ||  el.contains(efp(rect.right, rect.bottom))
            ||  el.contains(efp(rect.left,  rect.bottom)));
        }
    };
})(jQuery, window);